module.exports = __webpack_public_path__ + "img/irg_company_logo.a030f489.png";